import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const generateImgixUrl = (url) => {
  const res = url.replace('https://front.travpromobile.com/', 'https://imgtravpromobile.imgix.net/');
  const returnValue = res + '?fit=clip&w=200&h=auto';
  return returnValue;
};

const ContactViewCard = ({ name, title, website, telephone, address, mails, imageUrl }) => {
  return (
    <div className="contactViewItem">
      <div className="contactView__Content">
        <img className="headshot" src={generateImgixUrl(imageUrl)} alt={`${name}`} />
        <h1>{name}</h1>
        <h2>{title}</h2>
        <p className='address'>{address && <strong>{address}</strong>}</p>
        <a href={`tel:${telephone.trim()}`}>
          <FontAwesomeIcon icon={['fas', 'phone']} />
          {telephone}
        </a>
        {mails.map((mail) => (
          <a href={`mailto:${mail.email}`}>
            <FontAwesomeIcon icon={['fas', 'envelope']} />
            {mail.email}
          </a>
        ))}
        <hr />
        {website && <a href={website}>{website}</a>}
      </div>
    </div>
  );
};

export default ContactViewCard;
